import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { driversService } from '../../services/driversService';
import { DateUtils } from '../../helpers/dateUtils';
import { ReferralStatusUtil, ReferralStatus } from '../../models/analytics/directions/directionsModels';

interface Props {
    open: boolean;
    onClose: () => void;
    driverId: number | null;
    driverFio: string;
}

export const DirectionsHistoryModal: React.FC<Props> = ({ open, onClose, driverId, driverFio }) => {
    const [rows, setRows] = useState<Array<{ date: string; statusId: number; status: string }>>([]);

    useEffect(() => {
        if (open && driverId) {
            driversService.getReferralStatusHistory(driverId).then(r => setRows(r.data.data));
        }
    }, [open, driverId]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>История изменений — {driverFio}</DialogTitle>
            <DialogContent>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Дата изменения</TableCell>
                            <TableCell>Изменение</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((r, i) => (
                            <TableRow key={i}>
                                <TableCell>{DateUtils.formatDateTime(r.date)}</TableCell>
                                <TableCell>{`Статус: ${ReferralStatusUtil.getStringValue(r.status as unknown as ReferralStatus)}`}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>
    );
};


